module.exports = __webpack_public_path__ + "img/icon-category-casarodante-bg.b6246a2b.jpg";